import React from 'react';
import { Button, ButtonProps } from '@mui/material';

interface Props extends ButtonProps {
  success?: boolean;
  error?: string;
  loading?: boolean;
}

const CustomButton = ({ variant = 'contained', ...rest }: Props) => {
  return <Button variant={variant} disableElevation {...rest} />;
};

export default CustomButton;
